export const SIDEBAR_WIDTH = 256;
export const SIDEBAR_WIDTH_CLOSED = 80;
export const SIDEBAR_SLICE_NAME = 'sidebar_slice';
export const PATH_IMAGE_PASSIO = '/images/login/passio-logo.png';
export const PATH_IMAGE_PASSIO_DARK = '/images/login/logo-brand-dark.png';
export const PATH_IMAGE_PASSIO_FOR_HOST = '/images/login/passio-host_dark.png';
export const PATH_IMAGE_PASSIO_FOR_AGENCY = '/images/login/passio-logo_default.png';
